<ng-container *ngIf="reportState$ | async as reportState">
  <div *ngIf="reportState.data?.companyReports?.length && !hidden" class="dashboard-statistics-table-wrap">
    <div class="chart-wrap">
      <div class="row">
        <div class="col-6">
          <div class="doughnut-chart-holder" [@dive]="doughnutDiveState" (@dive.done)="updatePdfRef(doughnutChart)">
            <canvas
              #doughnutChart="doughnut-chart"
              appDoughnutChart
              [values]="getChartValues(reportState.data.companyReports)"
              width="128"
              height="128"
            ></canvas>
          </div>
        </div>
        <div class="col-6">
          <div class="data-wrap" [@dive]="doughnutDiveState">
            <div class="percentage">
              {{ formatPercentage(reportState.data.companyReports[selectedRecord].percentage) }}%
            </div>
            <div class="title">
              {{ reportState.data.companyReports[selectedRecord].title }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="dm" class="input_container grouping-container">
      <div class="inner-wrap clearfix row" @toggle>
        <label for="grouping" i18n="@@dashboard-right.dashboardOptionsFilterBy">Show</label>
        <ng-select
          id="grouping"
          [items]="groupingOptions"
          [searchable]="false"
          [clearable]="false"
          class="dashboard-select small"
          [(ngModel)]="grouping"
          bindValue="value"
          (change)="updateReport()"
        >
          <ng-template ng-option-tmp let-item="item">
            <span class="ng-option-label">{{ item.label }}</span>
          </ng-template>
          <ng-template ng-label-tmp let-item="item">
            <span class="ng-value-label">{{ item.label }}</span>
          </ng-template>
        </ng-select>
      </div>
    </div>
    <div
      #slider
      class="statistics-table-container"
      [@autoHeight]="{
        value: sliderHeightState,
        params: {
          sliderHeight: sliderHeight,
          sliderTargetHeight: sliderTargetHeight
        }
      }"
    >
      <div
        #details
        *ngIf="openedRecord > -1"
        class="statistics-details-wrap"
        [@slide]="openedRecord > -1 ? 'in' : 'outLeft'"
        (@slide.start)="startHeightAnimation(slider, details, statistics)"
        (@slide.done)="sliderHeightState = 'off'"
      >
        <table>
          <tr class="heading" (click)="openedRecord = -1">
            <td>{{ openedRecord + 1 }}</td>
            <td class="title">
              {{ reportState.data.companyReports[openedRecord].title }}
            </td>
            <td class="back-link">
              <span class="fa-angle-left"></span>
            </td>
          </tr>
          <ng-container *ngIf="showDetails">
            <tr *ngFor="let item of reportState.data.companyReports[openedRecord].details" class="content">
              <ng-container *ngFor="let field of item | keyvalue">
                <td></td>
                <ng-container [ngSwitch]="field.key">
                  <ng-container *ngSwitchCase="'nights'">
                    <td class="prop-name">
                      {{dashboardDetailsNights}}
                    </td>
                  </ng-container>
                  <ng-container *ngSwitchCase="'average_nightcost'">
                    <td class="prop-name">
                      {{dashboardDetailsAverageNightCost}}
                    </td>
                  </ng-container>
                  <ng-container *ngSwitchCase="'base_turnover'">
                    <td class="prop-name">
                      {{dashboardDetailsBaseTurnover}}
                    </td>
                  </ng-container>
                  <ng-container *ngSwitchCase="'fare'">
                    <td class="prop-name">
                      {{dashboardDetailsFare}}
                    </td>
                  </ng-container>
                  <ng-container *ngSwitchCase="'taxes'">
                    <td class="prop-name">
                      {{dashboardDetailsTaxes}}
                    </td>
                  </ng-container>
                </ng-container>
                <td>
                  {{ field.value && formatDetailsValue(field) }}
                </td>
              </ng-container>
            </tr>
          </ng-container>
        </table>

        <app-dashboard-origins
          *ngIf="showOrigins"
          [items]="reportState.data.companyReports[openedRecord].originsDestinationsReport"
          [recordTitle]="reportState.data.companyReports[openedRecord].title"
          [allRecordsTitle]="originsAllRecordsTitle"
        ></app-dashboard-origins>
      </div>
      <div
        #statistics
        class="statistics-table-wrap"
        [@slide]="openedRecord > -1 ? 'outRight' : 'in'"
        (@slide.done)="sliderHeightState = 'off'"
      >
        <table class="statistics-table">
          <tr
            *ngFor="let record of reportState.data.companyReports; let i = index"
            [ngClass]="{ current: selectedRecord === i }"
            [@dive]="{
              value: 'in',
              params: {
                distance: '-40px',
                duration: '200ms',
                easing: 'cubic-bezier(.77, 0, .18, 1)'
              }
            }"
            (click)="selectRecord(i)"
          >
            <td class="pos">{{ i + 1 }}</td>
            <td class="title">{{ record.title }}</td>
            <td class="value">
              {{ formatNumber(record.value, symbolType) + ' ' + symbolType }}
            </td>
            <td class="percentage">{{ formatPercentage(record.percentage) }}%</td>
            <td *ngIf="showDetails || showOrigins" class="details-link">
              <span class="fa-angle-right"></span>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</ng-container>
